import Swiper from 'swiper/bundle';

let TeaserArticles = {
	_init: () => {
		document.addEventListener('DOMContentLoaded', TeaserArticles._ready);
	},
	_ready: () => {
		TeaserArticles._initSwiper();
	},
	_initSwiper: () => {
		const swiper = new Swiper('.teaserarticles-slider', {
			freeMode: true,
			slidesPerView: 'auto',
			grabCursor: true,
			simulateTouch: true,
		});
	}
};

TeaserArticles._init();